import { useActions } from "@/store/vuex-composition-mappers";
import { makeLogger } from "@/shared/consola";
import { defineStore } from "pinia";
import { useSessionStorage } from "@vueuse/core";

const separateItemNameAndId = (fieldName: string) => {
    const [name, id] = fieldName.split("_");
    return { name, id };
};

const STORE_NAME = "magic-field-exchange";
const logger = makeLogger("🍍" + STORE_NAME);

export const useMagicFieldExchangeStore = defineStore(STORE_NAME, () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { magicallyExchangeContent } = useActions("page", ["magicallyExchangeContent"]);
    // using session storage for now because we got shared state between iframe:
    const magicThingsLoading = useSessionStorage<string[]>(STORE_NAME, []);

    // clear on start:
    magicThingsLoading.value = [];

    return {
        async exchangeContent({ blockId, fieldName }: { blockId: number; fieldName: string }) {
            const { name, id } = separateItemNameAndId(fieldName);
            const fieldCacheId = `${blockId}_${name}`; // cache by blockId and fieldName (for array items we use "name" to prevent sending multiple request for same array field as a whole
            magicThingsLoading.value.push(fieldCacheId);
            logger.trace("saving the field:", fieldCacheId);
            await magicallyExchangeContent({
                blockId,
                fieldName: name,
                itemId: id,
            });
            magicThingsLoading.value = magicThingsLoading.value.filter((v) => v !== fieldCacheId);
            logger.trace("removing the field:", fieldCacheId);
        },
        isBlockFieldExchanging(blockId: number, fieldName: string) {
            const { name } = separateItemNameAndId(fieldName);
            const fieldCacheId = `${blockId}_${name}`;
            //logger.trace("CHECKING the field:", fieldCacheId);
            return magicThingsLoading.value.includes(fieldCacheId);
        },
    };
});
